import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Close } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { LinkButton, Stack, Tooltip } from '@lyearn/ui';
import {
  GROUPS_ITEM_PROPS,
  GROUPS_PROPS,
} from '@/components/Form/components/VisibilitySettings/components/RestrictedVisibilitySettingsSelectedList/components/RestrictedVisibilitySettingsSelectedGroupsList/components/RestrictedGroupListItem/consts';
import { listItemStyle } from '@/components/Form/components/VisibilitySettings/components/RestrictedVisibilitySettingsSelectedList/components/RestrictedVisibilitySettingsSelectedGroupsList/components/RestrictedGroupListItem/style';
import GroupTab, { GroupTabProps } from '@/modules/corporate/modules/group/components/GroupTab';
import { GroupItemMode } from '@/modules/corporate/modules/group/types';
import { VisibilitySettingsRestrictionTypeEnum } from '@/types/schema';

interface ListItemProps {
  group: GroupTabProps['group'];
  mode: GroupItemMode;
  onRemove: (props: {
    removedGroupId?: string;
    removedContextualGroupId?: VisibilitySettingsRestrictionTypeEnum;
  }) => void;
  disabled?: boolean;
  className?: string;
  hideRemoveButton?: boolean;
}

function ListItem(props: ListItemProps) {
  const { t } = useTranslation('Group');
  const { group, onRemove, disabled, mode, className, hideRemoveButton } = props;
  const groupClasses = GROUPS_PROPS[mode];
  const groupItemClasses = GROUPS_ITEM_PROPS[mode];

  const _onRemove = useCallback(() => {
    if (group.type === 'ContextualUserGroupType') {
      onRemove({ removedContextualGroupId: group.id });
      return;
    }

    onRemove({ removedGroupId: group.id });
  }, [onRemove, group]);

  return (
    <Stack
      className={cn(listItemStyle, className, groupClasses, 'flex-shrink-0 rounded-8', {
        'group hover:bg-s-info-light': !disabled,
      })}>
      <Stack
        className={cn('group-list-item w-full', groupItemClasses, { disabled: disabled })}
        justifyContent="between">
        <GroupTab group={group} mode={mode} />
        {!disabled && !hideRemoveButton ? (
          <Tooltip placement="right" title={t('Group:Modal.RemoveGroup') ?? ''}>
            <LinkButton
              className="flex-shrink-0 py-2 px-4 px-0 opacity-0 transition duration-150 ease-linear group-hover:opacity-100"
              color={'internal'}
              onClick={_onRemove}>
              <Close />
            </LinkButton>
          </Tooltip>
        ) : null}
      </Stack>
    </Stack>
  );
}

export default ListItem;
